import React from 'react';
import { Flag, Library, Menu } from 'lucide-react';

interface ChatHeaderProps {
  onOpenSidebar: () => void;
  onReportClick: () => void;
  serviceStatus?: 'online' | 'maintenance';
  onOpenTemplates?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  onOpenSidebar, onReportClick, serviceStatus = 'online', onOpenTemplates
}) => (
  <header className="pointer-events-none fixed left-0 right-0 top-0 z-40 flex h-[calc(4.5rem+env(safe-area-inset-top,0px))] items-center justify-between px-2 pt-[env(safe-area-inset-top,0px)] sm:px-4 md:h-20 md:px-5 md:pt-0">
    <button type="button" onClick={onOpenSidebar} className="pointer-events-auto flex h-11 w-11 items-center justify-center rounded-full border border-juris/10 bg-panel/90 text-ink shadow-lg shadow-black/10 backdrop-blur-xl transition hover:bg-juris-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-juris" aria-label="Abrir menú lateral">
      <Menu size={22} />
    </button>
    <div className="pointer-events-auto flex items-center gap-1 sm:gap-2">
      {onOpenTemplates && (
        <button type="button" onClick={onOpenTemplates} className="flex h-11 min-w-11 items-center justify-center gap-2 rounded-full border border-juris/10 bg-panel/90 px-3 text-ink shadow-lg shadow-black/10 backdrop-blur-xl transition hover:bg-warning-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warning" title="Plantillas de diligencias" aria-label="Plantillas de diligencias">
          <Library size={18} className="text-juris" />
          <span className="hidden text-sm font-bold md:inline">Plantillas de diligencias</span>
        </button>
      )}
      <button type="button" onClick={onReportClick} className="flex h-11 min-w-11 items-center justify-center gap-2 rounded-full border border-juris/10 bg-panel/90 px-3 text-ink shadow-lg shadow-black/10 backdrop-blur-xl transition hover:bg-juris-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-juris" title="Reportar error" aria-label="Reportar error">
        <Flag size={18} className={serviceStatus === 'maintenance' ? 'text-danger' : 'text-juris'} />
        <span className="hidden text-sm font-bold md:inline">Reportar</span>
      </button>
    </div>
  </header>
);

export default ChatHeader;
